/**
 * Listagem operacional de títulos a receber.
 *
 * Endpoint real (backend): GET /loja/financeiro/titulos-receber
 */
import api from "services/api";
import type { ContasReceberFiltros } from "../types/contas-receber.types";
import type { ContasReceberApiResponse } from "../types/contas-receber.types";

export function montarParamsContasReceber(
  filtros: ContasReceberFiltros,
): Record<string, string | number | boolean> {
  const p: Record<string, string | number | boolean> = {};

  const page = filtros.page ?? 1;
  const limit = filtros.limit ?? 20;
  p.page = page;
  p.limit = limit;

  if (filtros.status?.trim()) p.status = filtros.status.trim();
  if (filtros.vencimentoInicio?.trim())
    p.vencimentoInicio = filtros.vencimentoInicio.trim();
  if (filtros.vencimentoFim?.trim()) p.vencimentoFim = filtros.vencimentoFim.trim();
  if (filtros.origem?.trim()) p.origem = filtros.origem.trim();
  if (filtros.centroCustoId?.trim())
    p.centroCustoId = filtros.centroCustoId.trim();
  if (filtros.pedidoId?.trim()) p.pedidoId = filtros.pedidoId.trim();
  if (filtros.busca?.trim()) p.busca = filtros.busca.trim();
  if (filtros.apenasVencidos === true) p.apenasVencidos = true;

  return p;
}

export async function listarContasReceber(filtros: ContasReceberFiltros): Promise<{
  data: ContasReceberApiResponse | null;
  status: number;
}> {
  const params = montarParamsContasReceber(filtros);
  const res = await api.get<ContasReceberApiResponse>(
    "/loja/financeiro/titulos-receber",
    { params },
  );
  return { data: res.data ?? null, status: res.status };
}
